import React from 'react'

function YearInputField(props) {
    return (
        <div className="input-field col s6">
            <input type="number" id="yearDate" onChange={(e)=>props.handleChange(e)} className="validate"/>
            <label className="active" htmlFor="yearDate">Year</label>
       </div>
    )
}

export default YearInputField
